import { UploadSquareImage } from './UploadSquareImage'
import { withUploadSquareImage } from './withUploadSquareImage'

const ConnectedUploadSquareImage = withUploadSquareImage(UploadSquareImage)

export { ConnectedUploadSquareImage as UploadSquareImage }
